import { useAppSelector } from '../../global/hooks';
import { ModalBody } from '../../global/styles';
import { useGetArrangementsQuery, useGetUserQuery } from '../../store/apiSlice';
import { selectBpm, selectTimeSignature } from '../../store/appSlice';
import { selectSections } from '../../store/sectionsSlice';
import Arrangements from '../Arrangements';
import { RefObject } from 'react';

interface Props {
	saveRef: RefObject<HTMLButtonElement>;
}

export default function SaveBody({ saveRef }: Props) {
	const sections = useAppSelector(selectSections);
	const bpm = useAppSelector(selectBpm);
	const timeSignature = useAppSelector(selectTimeSignature);

	const { data: user } = useGetUserQuery();
	const { data: arrangements = [], isFetching } = useGetArrangementsQuery(user?.id ?? 0, {
		skip: user == null
	});

	const newArrangement = {
		name: '',
		sections,
		bpm,
		timeSignature
	};

	return (
		<ModalBody>
			<Arrangements arrangements={[newArrangement, ...arrangements]} isLoading={isFetching} />
		</ModalBody>
	);
}
